export default __webpack_public_path__ + "static/AbdulWasay-e52aa4352a78db8c150eb63972a0bc2d.png";